export default "__VITE_ASSET__Dg6V9DVM__"